export default __webpack_public_path__ + "static/media/Cypress-BDD.6f5bd5f5.jpg";